module.exports = __webpack_public_path__ + "img/ring_g_skip_0_1@3x.e890aca4.png";